import { Trans } from '@lingui/react'

import IconCross from 'views/components/atoms/Icon/IconCross'
import ButtonSmall from 'views/components/molecules/ButtonSmall'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

export const closeComponentForModal = () => (
  <ButtonSmall
    name="modal-close-button"
    href="#"
    primary
    data-clientside-hook="refinementList__cancel-selection"
  >
    <TextWithIcon icon={<IconCross />}>
      <span className="u-visuallyhidden@small-tiny">
        <Trans id="general.link.label.close" />
      </span>
    </TextWithIcon>
  </ButtonSmall>
)
